//import PeopleIcon from '@material-ui/icons/People';
import { Resource, ResourceElement } from 'react-admin';
import UserList from './list';
import PersonIcon from '@mui/icons-material/Person';
import { getResourcePath } from 'admin/pages-factory';

/**
 * Компонент страницы - Пользователи
 * @param permissions - полученные права доступа
 * @returns - React.Node
 */
 const UsersPage = (permissions: any): ResourceElement | null => {
  // в упрощенном варианте - пока есть права, рендерим страницу(вкладку) - пользователи
  return permissions
              ? <Resource name= {getResourcePath('users', 'accounts')}
                          list={UserList}
                          icon={PersonIcon}
                          options={{label: "Users"}} />
              : null;
}


export default UsersPage;
